export default __webpack_public_path__ + "static/undertone-5753f44844aef79be3bebe12a395fdf8.svg";